<template>
    <ContentPage title="Comisioane - Cumpărător">
        <div>
            <p>
                Cu excepția cazului în care se convine altfel în scris sau se indică altfel în Condițiile speciale de licitație, Comisioanele datorate
                de cumpărător către Fleequid pentru cumpărarea și vânzarea fiecărui vehicul individual realizată prin intermediul Marketplace-ului sau
                al serviciilor și sistemelor de cumpărare și vânzare ale Fleequid sunt următoarele:
            </p>
        </div>

        <div class="mx-auto flex flex-col items-center gap-2">
            <div>
                <SaleFeesInfoTable />
            </div>
        </div>

        <div>
            <p><strong>*</strong> fără TVA</p>
            <p><strong>**</strong> plus TVA dacă este cazul</p>
        </div>

        <div>
            <p class="mb-1 font-bold">Exemplul 1:</p>
            <p>Preț de adjudecare: 6.000&nbsp;€ +&nbsp;TVA</p>
            <p>
                Comision datorat către Fleequid de către Cumpărător: <br class="md:hidden" />
                <span class="font-medium">
                    sumă fixă de 250&nbsp;€ +&nbsp;(6.000&nbsp;€ * 8,75%) =
                    <span class="whitespace-nowrap">775&nbsp;€ +&nbsp;TVA</span>
                </span>
            </p>
        </div>

        <div>
            <p class="mb-1 font-bold">Exemplul 2:</p>
            <p>Preț de adjudecare: 180.000&nbsp;€ +&nbsp;TVA</p>
            <p>
                Comision datorat către Fleequid de către Cumpărător: <br class="md:hidden" />
                <span class="font-medium">
                    250&nbsp;€ +&nbsp;(100.000&nbsp;€ * 8,75%) +&nbsp;(80.000&nbsp;€ * 3,75%) =
                    <span class="whitespace-nowrap">12.000&nbsp;€ +&nbsp;TVA</span>
                </span>
            </p>
        </div>
    </ContentPage>
</template>
